// extracted by mini-css-extract-plugin
module.exports = {"fishBuy404":"EmptyStateResult_fishBuy404__Tla_d","fishBuy404Text":"EmptyStateResult_fishBuy404Text___u218"};